module.exports = __webpack_public_path__ + "static/media/fssc22000.bf1c88d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fssc22000.png
// module id = 251
// module chunks = 0